import { render, staticRenderFns } from "./TablaPivotGrid.vue?vue&type=template&id=d9178a88"
import script from "./TablaPivotGrid.vue?vue&type=script&lang=js"
export * from "./TablaPivotGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports